<svg class="intake-svg" viewBox="0 13.14 124 97.72" aria-hidden="true" focusable="false">
  <defs>
    <clipPath id="av-intake-clip">
      <path
        d="M39.66,78.9l7.78-7.78h7.44c3.49,7.76,11.28,13.17,20.34,13.17,12.31,0,22.3-9.98,22.3-22.3s-9.98-22.3-22.3-22.3c-9.37,0-17.39,5.79-20.69,13.98h-24.34c.26.68.4,1.41.4,2.19s-.14,1.51-.4,2.19h23.09c-.23,1.28-.35,2.6-.35,3.94,0,1.63.18,3.22.51,4.75h-7.8l-7.78,7.78H14.27c.26.68.4,1.42.4,2.19s-.14,1.51-.4,2.19h25.4Z"
      ></path>
      <path
        d="M6.13,70.58c-3.39,0-6.13,2.74-6.13,6.13s2.74,6.13,6.13,6.13,6.13-2.74,6.13-6.13-2.74-6.13-6.13-6.13Z"
      ></path>
      <path
        d="M75.14,13.14c-20.69,0-38.39,12.86-45.5,31.03h7c6.73-14.52,21.44-24.59,38.5-24.59,23.43,0,42.42,18.99,42.42,42.42s-18.99,42.42-42.42,42.42c-9.57,0-18.4-3.17-25.49-8.52h0c-.21-.16-.42-.32-.63-.48-1.53-1.2-2.98-2.5-4.32-3.9h0s0,0,0,0h-14.5c.26.68.4,1.41.4,2.19s-.14,1.51-.4,2.19h9.79c8.87,9.22,21.35,14.95,35.16,14.95,26.99,0,48.86-21.87,48.86-48.86S102.12,13.14,75.14,13.14Z"
      ></path>
      <path
        d="M22.05,87.59c-3.39,0-6.13,2.74-6.13,6.13s2.74,6.13,6.13,6.13,6.13-2.74,6.13-6.13-2.74-6.13-6.13-6.13Z"
      ></path>
      <path
        d="M22.05,62c3.39,0,6.13-2.74,6.13-6.13s-2.74-6.13-6.13-6.13-6.13,2.74-6.13,6.13,2.74,6.13,6.13,6.13Z"
      ></path>
    </clipPath>
    <clipPath id="av-intake-ringhalo-clip">
      <path d="M-10,-10 H134 V170 H-10 V80 H40 V44.17 H-10 Z"></path>
    </clipPath>
  </defs>

  <g class="intake-blooms">
    <circle class="intake-bloom intake-bloom--top" cx="22.05" cy="55.87" r="6.13"></circle>
    <circle class="intake-bloom intake-bloom--mid" cx="6.13" cy="76.71" r="6.13"></circle>
    <circle class="intake-bloom intake-bloom--bot" cx="22.05" cy="93.72" r="6.13"></circle>
    <circle class="intake-core-bloom intake-core-bloom--a" cx="75.22" cy="61.99" r="22.3"></circle>
    <circle class="intake-core-bloom intake-core-bloom--b" cx="75.22" cy="61.99" r="22.3"></circle>
  </g>

  <g class="intake-halos-wide">
    <path class="intake-stroke intake-w-trace-wide intake-top-l14" d="M30.19,55.86 H64"></path>
    <path
      class="intake-stroke intake-w-trace-wide intake-mid-l14"
      d="M14.27,76.71 H38.76 L46.54,68.93 H64"
    ></path>
    <path
      class="intake-stroke intake-w-route-wide intake-bot-l32 intake-ringhalo"
      d="M30.2,93.71 H42.31 A45.64,45.64 0 1,0 31.73,47.9"
    ></path>
  </g>
  <g class="intake-halos-near">
    <path class="intake-stroke intake-w-trace-near intake-top-l14" d="M30.19,55.86 H64"></path>
    <path
      class="intake-stroke intake-w-trace-near intake-mid-l14"
      d="M14.27,76.71 H38.76 L46.54,68.93 H64"
    ></path>
    <path
      class="intake-stroke intake-w-route-near intake-bot-l32 intake-ringhalo"
      d="M30.2,93.71 H42.31 A45.64,45.64 0 1,0 31.73,47.9"
    ></path>
  </g>

  <g class="intake-mark-group">
    <path
      class="intake-mark"
      d="M39.66,78.9l7.78-7.78h7.44c3.49,7.76,11.28,13.17,20.34,13.17,12.31,0,22.3-9.98,22.3-22.3s-9.98-22.3-22.3-22.3c-9.37,0-17.39,5.79-20.69,13.98h-24.34c.26.68.4,1.41.4,2.19s-.14,1.51-.4,2.19h23.09c-.23,1.28-.35,2.6-.35,3.94,0,1.63.18,3.22.51,4.75h-7.8l-7.78,7.78H14.27c.26.68.4,1.42.4,2.19s-.14,1.51-.4,2.19h25.4Z"
    ></path>
    <path
      class="intake-mark"
      d="M6.13,70.58c-3.39,0-6.13,2.74-6.13,6.13s2.74,6.13,6.13,6.13,6.13-2.74,6.13-6.13-2.74-6.13-6.13-6.13Z"
    ></path>
    <path
      class="intake-mark"
      d="M75.14,13.14c-20.69,0-38.39,12.86-45.5,31.03h7c6.73-14.52,21.44-24.59,38.5-24.59,23.43,0,42.42,18.99,42.42,42.42s-18.99,42.42-42.42,42.42c-9.57,0-18.4-3.17-25.49-8.52h0c-.21-.16-.42-.32-.63-.48-1.53-1.2-2.98-2.5-4.32-3.9h0s0,0,0,0h-14.5c.26.68.4,1.41.4,2.19s-.14,1.51-.4,2.19h9.79c8.87,9.22,21.35,14.95,35.16,14.95,26.99,0,48.86-21.87,48.86-48.86S102.12,13.14,75.14,13.14Z"
    ></path>
    <path
      class="intake-mark"
      d="M22.05,87.59c-3.39,0-6.13,2.74-6.13,6.13s2.74,6.13,6.13,6.13,6.13-2.74,6.13-6.13-2.74-6.13-6.13-6.13Z"
    ></path>
    <path
      class="intake-mark"
      d="M22.05,62c3.39,0,6.13-2.74,6.13-6.13s-2.74-6.13-6.13-6.13-6.13,2.74-6.13,6.13,2.74,6.13,6.13,6.13Z"
    ></path>
  </g>

  <circle class="intake-tint intake-tint--top" cx="22.05" cy="55.87" r="6.13"></circle>
  <circle class="intake-tint intake-tint--mid" cx="6.13" cy="76.71" r="6.13"></circle>
  <circle class="intake-tint intake-tint--bot" cx="22.05" cy="93.72" r="6.13"></circle>

  <g class="intake-onmark">
    <g class="intake-body">
      <path class="intake-stroke intake-w-trace intake-top-l14" d="M30.19,55.86 H64"></path>
      <path
        class="intake-stroke intake-w-trace intake-mid-l14"
        d="M14.27,76.71 H38.76 L46.54,68.93 H64"
      ></path>
      <path
        class="intake-stroke intake-w-ring intake-bot-l36"
        d="M30.2,93.71 H42.31 A45.64,45.64 0 1,0 31.73,47.9"
      ></path>
    </g>
  </g>
  <g class="intake-onmark intake-heads">
    <path class="intake-stroke intake-w-trace intake-top-l5" d="M30.19,55.86 H64"></path>
    <path
      class="intake-stroke intake-w-trace intake-mid-l5"
      d="M14.27,76.71 H38.76 L46.54,68.93 H64"
    ></path>
    <path
      class="intake-stroke intake-w-ring intake-bot-l10"
      d="M30.2,93.71 H42.31 A45.64,45.64 0 1,0 31.73,47.9"
    ></path>
  </g>

  <circle class="intake-core" cx="75.22" cy="61.99" r="22.3"></circle>
  <circle class="intake-core-tint" cx="75.22" cy="61.99" r="22.3"></circle>
</svg>
